/* tslint:disable */
/* eslint-disable */
/**
 * KDS API
 * Internal KDS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CheckKdsUpdates200ResponseAnyOf } from './CheckKdsUpdates200ResponseAnyOf';
import {
    CheckKdsUpdates200ResponseAnyOfFromJSON,
    CheckKdsUpdates200ResponseAnyOfFromJSONTyped,
    CheckKdsUpdates200ResponseAnyOfToJSON,
    CheckKdsUpdates200ResponseAnyOfToJSONTyped,
} from './CheckKdsUpdates200ResponseAnyOf';

/**
 * 
 * @export
 * @interface CheckKdsUpdates200Response
 */
export interface CheckKdsUpdates200Response {
    /**
     * 
     * @type {string}
     * @memberof CheckKdsUpdates200Response
     */
    version: string;
    /**
     * 
     * @type {string}
     * @memberof CheckKdsUpdates200Response
     */
    url: string;
    /**
     * 
     * @type {string}
     * @memberof CheckKdsUpdates200Response
     */
    checksum: string;
    /**
     * 
     * @type {number}
     * @memberof CheckKdsUpdates200Response
     */
    size?: number;
    /**
     * 
     * @type {string}
     * @memberof CheckKdsUpdates200Response
     */
    releaseDate?: string;
}

/**
 * Check if a given object implements the CheckKdsUpdates200Response interface.
 */
export function instanceOfCheckKdsUpdates200Response(value: object): value is CheckKdsUpdates200Response {
    if (!('version' in value) || value['version'] === undefined) return false;
    if (!('url' in value) || value['url'] === undefined) return false;
    if (!('checksum' in value) || value['checksum'] === undefined) return false;
    return true;
}

export function CheckKdsUpdates200ResponseFromJSON(json: any): CheckKdsUpdates200Response {
    return CheckKdsUpdates200ResponseFromJSONTyped(json, false);
}

export function CheckKdsUpdates200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CheckKdsUpdates200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'version': json['version'],
        'url': json['url'],
        'checksum': json['checksum'],
        'size': json['size'] == null ? undefined : json['size'],
        'releaseDate': json['releaseDate'] == null ? undefined : json['releaseDate'],
    };
}

export function CheckKdsUpdates200ResponseToJSON(json: any): CheckKdsUpdates200Response {
    return CheckKdsUpdates200ResponseToJSONTyped(json, false);
}

export function CheckKdsUpdates200ResponseToJSONTyped(value?: CheckKdsUpdates200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'version': value['version'],
        'url': value['url'],
        'checksum': value['checksum'],
        'size': value['size'],
        'releaseDate': value['releaseDate'],
    };
}

